'use client';

import { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { useRouter } from '@/i18n/routing';

// Re-runs the server component so the Market page pulls fresh quotes without a
// full reload (data freshness is still bounded by the backend cache TTL).
export default function RefreshButton() {
  const router = useRouter();
  const [spinning, setSpinning] = useState(false);

  function refresh() {
    if (spinning) return;
    setSpinning(true);
    router.refresh();
    setTimeout(() => setSpinning(false), 1200);
  }

  return (
    <button
      onClick={refresh}
      aria-label="刷新行情"
      className="flex h-8 w-8 items-center justify-center rounded-full text-zinc-400 active:scale-95"
    >
      <RefreshCw size={16} className={spinning ? 'animate-spin' : ''} />
    </button>
  );
}
